var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-modal',{attrs:{"show":_vm.show},on:{"closing":function($event){_vm.show = false}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }